import ActiveController from "rapid/controller";

export class phoneMsgController extends ActiveController {
    constructor($injector) {
        "ngInject";
        super($injector);
    }
}



// WEBPACK FOOTER //
// ./sources/components/common/phone-msg/phone-msg.controller.js